export class FeedbackChallengeQuerySearch {
  constructor(
    readonly isComplete: boolean,
    readonly projectId?: number,
    readonly measureId?: number,
    readonly sortDirection?: string,
    readonly sortField?: string,
    readonly startRecord?: number,
    readonly endRecord?: number
  ) { }
}
